import { request } from "utils/request";
import { AxiosPromise } from "axios";
import { AttendanceLeaveItem } from "types/attendance";

export const attendanceApi = {
  findAll: (params: { month: number; year: number; search?: string; departmentId?: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/attendance",
      params,
    }),

  saveLeave: (data: { month: number; year: number; items: AttendanceLeaveItem[] }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/attendance/leave",
      method: "post",
      data,
    }),

  lock: (data: { month: number; year: number }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/attendance/lock",
      method: "post",
      data,
    }),

  unlock: (data: { month: number; year: number; note: string }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/attendance/unlock",
      method: "post",
      data,
    }),
};
